import { useState, type FormEvent } from 'react';
import { Redirect } from 'wouter';
import { ApiError } from '@/core/http/AdminApiClient';
import { useAuth } from '@/core/auth/AuthProvider';

export function LoginPage() {
  const { state, login } = useAuth();
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (state === 'authenticated') return <Redirect to="/app/guides" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(token);
    } catch (reason) {
      setError(reason instanceof ApiError && reason.status === 401
        ? '访问令牌无效，请确认后重试。'
        : '暂时无法建立安全会话，请稍后重试。');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login">
      <section className="login__brand" aria-labelledby="login-brand-title">
        <span className="brand-mark">走</span>
        <p className="eyebrow">ZOUQI OPERATIONS</p>
        <h1 id="login-brand-title">把好内容，整理成一条能出发的路线。</h1>
        <p>攻略、地点与用户线索在同一个工作台协作，所有发布动作都有明确状态。</p>
      </section>
      <section className="login__panel" aria-labelledby="login-title">
        <div>
          <p className="eyebrow">安全登录</p>
          <h2 id="login-title">进入运营后台</h2>
          <p className="muted">令牌仅用于换取当前浏览器的加密会话，不会写入本地存储。</p>
        </div>
        <form onSubmit={submit}>
          <label htmlFor="admin-token">管理访问令牌</label>
          <input
            id="admin-token"
            type="password"
            autoComplete="current-password"
            value={token}
            onChange={(event) => setToken(event.target.value)}
            required
            autoFocus
          />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button button--primary button--full" disabled={submitting}>
            {submitting ? '正在验证…' : '安全进入'}
          </button>
        </form>
      </section>
    </main>
  );
}
